import * as React from 'react'

import { chartsByType } from '../../../charts/charts'
import { Select, SelectOption } from '../../../components'
import { ChartElementType } from '../../../constants/common'
import Element from '../../../models/element'
import { useForceUpdate } from '../../../utils/force-update'
import { useChartLayoutGlobalModel } from '../chart-layout-model'
import { handleTypeChange } from './model-manipulation'

interface IChartType {
  value: ChartElementType
  label?: string
  iconName?: string
}

const DEFAULT_TYPES = Object.keys(chartsByType)
  .filter(
    (item) =>
      ![ChartElementType.PerfChart, ChartElementType.MultiLineChart, ChartElementType.MarketSentiment].includes(
        item as ChartElementType
      )
  )
  .map((item) => ({
    value: item,
    label: chartsByType[item as ChartElementType].label,
    iconName: chartsByType[item as ChartElementType].iconName,
  })) as IChartType[]

export function ChartStyleSelect() {
  const { forceUpdate } = useForceUpdate()
  const { chartLayoutModel } = useChartLayoutGlobalModel()
  const chartType =
    chartLayoutModel &&
    chartLayoutModel
      ?.charts()
      .first()
      ?.getAllElements()
      .find((element: Element) => element.isChart())?.instance.type

  const onTypeChange = React.useCallback(
    (type: ChartElementType) => {
      if (chartLayoutModel) {
        handleTypeChange({ type, chartLayoutModel })
        forceUpdate()
      }
    },
    [chartLayoutModel, forceUpdate]
  )

  if (!chartLayoutModel) return null

  return (
    <Select
      data-testid="chart-style-select"
      aria-label="Chart type"
      label="Chart type"
      onChange={(item: IChartType) => {
        onTypeChange(item.value)
      }}
      value={chartType}
      items={DEFAULT_TYPES}
      className="w-full"
      size="medium"
      leftContent={DEFAULT_TYPES.find((item) => item.value === chartType)?.iconName}
    >
      {DEFAULT_TYPES.map((item) => (
        <SelectOption data-testid={`chart-style-select-${item.value}`} key={item.value} leftContent={item.iconName}>
          {item.label}
        </SelectOption>
      ))}
    </Select>
  )
}
